import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  CENTER,
  ZOOM,
  PITCH,
  SATELLITE_BASEMAP_STYLE,
  STREET_BASEMAP_STYLE
} from '../config/constants'
import generateMaxBounds from '../utility/generateMaxBounds'

const MAX_ZOOM = 19
const MIN_ZOOM = 1

// Redux type and action creators
const { Types, Creators } = createActions({
  centerChanged: ['center'],
  toggleCenterChanged: ['center'],
  zoomChanged: ['zoom'],
  zoomIn: [],
  zoomOut: [],
  centerZoomChanged: ['center', 'zoom'],
  toggleZoomChanged: ['zoom'],
  maxBoundsChanged: ['maxBounds'],
  maxBoundsCenterZoomChanged: ['maxBounds', 'center', 'zoom'],
  pitchChanged: ['pitch'],
  pitchControlToggled: [],
  styleToggled: [],
  updateBounds: ['bounds'],
  reset: []
})

export const MapTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  basemap: 'street',
  bounds: {},
  center: CENTER,
  zoom: [ZOOM],
  maxBounds: null,
  pitch: PITCH,
  pitchControlVisible: false,
  style: STREET_BASEMAP_STYLE,
  toggleCenter: {},
  toggleZoom: [ZOOM]
})

// Redux reducers
export const centerChanged = (state, { center }) => {
  return state.merge({ center, toggleCenter: center })
}

export const zoomChanged = (state, { zoom }) => {
  return state.merge({ zoom: zoom })
}

export const zoomIn = state => {
  const { zoom } = state

  const nextZoom = zoom[0] >= MAX_ZOOM ? [MAX_ZOOM] : [zoom[0] + 1]

  return state.merge({ zoom: nextZoom })
}

export const zoomOut = state => {
  const { zoom } = state

  const nextZoom = zoom[0] <= MIN_ZOOM ? [MIN_ZOOM] : [zoom[0] - 1]
  
  return state.merge({ zoom: nextZoom })
}

export const centerZoomChanged = (state, { center, zoom }) => {
  return state.merge({ center, toggleCenter: center, zoom })
}

export const maxBoundsChanged = (state, { maxBounds }) => {
  // console.log('maxBoundsChanged')
  return state.merge({ maxBounds })
}

export const maxBoundsCenterZoomChanged = (
  state,
  { maxBounds, center, zoom }
) => {
  // console.log('maxBoundsCenterZoomChanged')
  const nextMaxBounds = generateMaxBounds(maxBounds, center, zoom)

  return state.merge({ maxBounds: nextMaxBounds, center, zoom })
}

export const toggleCenterChanged = (state, { center }) => {
  return state.merge({ toggleCenter: center })
}

export const toggleZoomChanged = (state, { zoom }) => {
  return state.merge({ toggleZoom: zoom })
}

export const pitchChanged = (state, { pitch }) => {
  return state.merge({ pitch })
}

export const pitchControlToggled = state => {
  const pitchControlVisible = !state.pitchControlVisible
  return state.merge({ pitchControlVisible })
}

export const styleToggled = state => {
  const { style } = state
  const newStyle =
    style === STREET_BASEMAP_STYLE
      ? SATELLITE_BASEMAP_STYLE
      : STREET_BASEMAP_STYLE
  return state.merge({ style: newStyle })
}

export const updateBounds = (state, { bounds }) => {
  return state.merge({ bounds })
}

export const mapReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.CENTER_CHANGED]: centerChanged,
  [Types.ZOOM_CHANGED]: zoomChanged,
  [Types.ZOOM_IN]: zoomIn,
  [Types.ZOOM_OUT]: zoomOut,
  [Types.CENTER_ZOOM_CHANGED]: centerZoomChanged,
  [Types.MAX_BOUNDS_CHANGED]: maxBoundsChanged,
  [Types.MAX_BOUNDS_CENTER_ZOOM_CHANGED]: maxBoundsCenterZoomChanged,
  [Types.TOGGLE_CENTER_CHANGED]: toggleCenterChanged,
  [Types.TOGGLE_ZOOM_CHANGED]: toggleZoomChanged,
  [Types.PITCH_CHANGED]: pitchChanged,
  [Types.PITCH_CONTROL_TOGGLED]: pitchControlToggled,
  [Types.STYLE_TOGGLED]: styleToggled,
  [Types.UPDATE_BOUNDS]: updateBounds,
  [Types.RESET]: mapReset
})



// WEBPACK FOOTER //
// ./src/redux/mapRedux.js